import axios from "axios";
import { CancelScenario, CancellationInfoRequest } from "redmond";

import { config } from "../../config";
import { getHotelChangeInfoPath } from "../paths";

/**
 * @description get change policy info for a booking
 * @param {CancellationInfoRequest} req Contains the reservation id
 * @return {CancelScenario} The cancellation info for the reservation passed in
 */
const getHotelChangeInfo = (
  req: CancellationInfoRequest
): Promise<CancelScenario> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(getHotelChangeInfoPath, req, {
        baseURL: config.baseURL,
      });

      resolve(res.data.value);
    } catch (e) {
      reject(e);
    }
  });

export default getHotelChangeInfo;
